import { createFileRoute } from '@tanstack/react-router'
import { Dashboard } from '../../pages'
import { dashboardSearchSchema } from '@/schemas'

export const Route = createFileRoute('/_layout/dashboard')({
    component: Dashboard,
    validateSearch: dashboardSearchSchema,
})
